module.exports = __webpack_public_path__ + "img/0002.3d81b401.svg";